import React from 'react';
import {css} from "@emotion/react";
import {useAuth} from "../Auth";
import {Button} from "../Button";
import {TriGrid} from "../TriGrid";
import {Grid} from "../Grid";
import {useNavBar} from "../NavBar";
import {Select} from "../Select";
import {Card} from "../TabsRoute/components/Card";
import {Typography} from "../Typography";
import {TSMMonitoringContext, TSMMonitoringProvider} from "../TSMTopFive/components/TSMMonitoringProvider";
import {TSMTrainsTable} from "./components/TSMTrains";
import {CallsByState} from "./components/CallsByState";
import {IconCallList} from './components/IconCallList';
import {TSMSvg} from "./components/TSMSvg";
import {ModalTrains,ModalTrainProps} from "./components/ModalTrains";
//import {Modal800CallLogs, Modal800CallLogsProps} from "../800CallLogs/components/Modal800CallLogs";
import {DustAlerts} from "./components/DustAlerts";
import {columnTitle, columnTitleEnd, rowTitle, selectContainer} from "./styles";

import moment from "moment";
import {useCallLogsByDate, useCallLogsById} from "../../sdk/queries";
//import {ModalNotification, ModalNotificationProps} from "./components/ModalNotification";
import {useLocationById} from "../../sdk/queries";

const yearOptions = [{label: "2023", value: "2023"},
		     {label: "2024", value: "2024"},
		     {label: "2025", value: "2025"},
		     {label: "2026", value: "2026"}];

const monthOptions = [
      {label: "January", value: "01"}
    , {label: "February", value: "02"}
    , {label: "March", value: "03"}
    , {label: "April", value: "04"}
    , {label: "May", value: "05"}
    , {label: "June", value: "06"}
    , {label: "July", value: "07"}
    , {label: "August", value: "08"}
    , {label: "September", value: "09"}
    , {label: "October", value: "10"}
    , {label: "November", value: "11"}
    , {label: "December", value: "12"}];


export const TsmAll: React.FC = () => {
    const {userRole} = useAuth();
    const {updatePage} = useNavBar();
    React.useLayoutEffect(() => {
        // Let the navbar know the current page displayed is this one
        updatePage("trackside-monitoring");
    }, []);

    const [open, setOpen] = React.useState(false);

    const [openNotification, setOpenNotification] = React.useState(false);

    const [mode, setMode] = React.useState<NonNullable<ModalTrainProps['mode']>>("view");
    const [currId, setCurrId] = React.useState<number | null>(null);

    const findLocationId = () => {
	var path = window.location.pathname;
	var lid_start = path.indexOf('tsm/');
	var lid_end = path.indexOf('/20');
	return Number(path.substring(lid_start+4,lid_end));
    }
    
    const findYear = (year: string) => {
        return yearOptions.find(x => x.value === year);
    }

    const findMonth = (month: string) => {
        return monthOptions.find(x => x.value === month);
    }

    const fixupUrl = (year: string, month: string) => {
	var path = window.location.pathname;
	var lastSlash = path.lastIndexOf('/');
	window.location.pathname = path.substring(0,lastSlash+1) +
	    year + '-' + month;
    }
    
    const {data, loading} = useLocationById({
	variables: {
	    id: String(findLocationId()),
	}
    });

    const location = data?.data;

    
    return (
        <TSMMonitoringProvider>
            <TSMMonitoringContext.Consumer>
                {({notifyCallLogsChange, selectedYear, setSelectedYear, selectedMonth, setSelectedMonth}) => (
                    <React.Fragment>
                        <Typography leftIcon={<TSMSvg/>} variant={"h1"}>Norfolk Southern Track Side Monitoring for {location?.name}</Typography>
			<TriGrid>
                        <div css={selectContainer}>
                            <Select value={findYear(selectedYear)} options={yearOptions}
                                    onChange={value => {
                                        if (value) {
                                            setSelectedYear(value.value)
					    fixupUrl(value.value,selectedMonth)
                                        }
                                    }}
                            />
                        </div>
                        <div css={selectContainer}>
                            <Select value={findMonth(selectedMonth)} options={monthOptions}
                                    onChange={value => {
                                        if (value) {
                                            setSelectedMonth(value.value)
					    fixupUrl(selectedYear,value.value)
                                        }
                                    }}
                            />
                        </div>
			<Typography variant={"h3"}></Typography>
			</TriGrid>
			<ModalTrains
		    modalProps={{
			open,
			width:700,
			onClose() {
			    setOpen(false);
			},
		    }}
		    mode={mode}
		    callLogId={currId}
		    locationId={location?.id}
		    />
			                        <Card>
                            <div css={rowTitle}>
                                <div css={columnTitle}>
                        <Typography variant={"h3"} >{location?.name} Monitored Trains</Typography>
                                </div>
                                
                            </div>
                            <TSMTrainsTable onView={(id) => {
                                setCurrId(id);
                                setMode("view");
                                setOpen(true);
                            }} location_id={findLocationId()}
		    period_s = {selectedYear + "-" + selectedMonth} />
                        </Card>

                    </React.Fragment>
                )}
            </TSMMonitoringContext.Consumer>
        </TSMMonitoringProvider>
    );
};

export default TsmAll;
